import { Col, Row } from "antd";
import React from "react";
import NoJobPositions from "../../Components/NoJobPositions";
import PlanExpired from "../../Components/PlanExpired";
import AgentInitializer from "./components/AgentInitializer";
import JobPositionsFilterMenu from "./components/JobPositionsFilterMenu";
import ListingPageContent from "./components/ListingPageContent";
import { useListingLogic } from "./useListingLogic";
import "./index.scss";

const Listing: React.FC = () => {
  const {
    isUserLoggedIn,
    isBasePlanExpired,
    filters,
    setFilters,
    jobDescriptions,
    positionsWithOpeningCount,
    pagination,
    appliedJobPostIds,
    handleViewDetails,
    handleApply,
    handleSearch,
    handlePageChange,
  } = useListingLogic();

  if (isBasePlanExpired) {
    return <PlanExpired />;
  }

  if (!positionsWithOpeningCount?.length) {
    return <NoJobPositions />;
  }

  return (
    <section className="listing-page" style={{ height: "100%" }}>
      <AgentInitializer isUserLoggedIn={isUserLoggedIn} />
      <Row style={{ height: "100%" }}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 8 }}
          lg={{ span: 6 }}
          xl={{ span: 4 }}
          style={{ height: "100%" }}
          className="listing_page_dashboard_filter_menu_col"
        >
          <JobPositionsFilterMenu
            filters={filters}
            positionsWithOpeningCount={positionsWithOpeningCount}
            setFilters={setFilters}
          />
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 16 }}
          lg={{ span: 18 }}
          xl={{ span: 20 }}
          style={{ height: "100%" }}
        >
          <ListingPageContent
            handleSearch={handleSearch}
            appliedJobPostIds={appliedJobPostIds}
            jobDescriptions={jobDescriptions}
            filters={filters}
            pagination={pagination}
            handlePageChange={handlePageChange}
            handleViewDetails={handleViewDetails}
            handleApply={handleApply}
            positionsWithOpeningCount={positionsWithOpeningCount}
            setFilters={setFilters}
          />
        </Col>
      </Row>
    </section>
  );
};

export default Listing;
